module.exports = __webpack_public_path__ + "img/english1_main.cff63479.png";